export default __webpack_public_path__ + "static/media/instagram-3.7a8cb05e.jpeg";